import { render, staticRenderFns } from "./ListaAtendentesUnidade.vue?vue&type=template&id=f7a8da68&scoped=true"
import script from "./ListaAtendentesUnidade.vue?vue&type=script&lang=js"
export * from "./ListaAtendentesUnidade.vue?vue&type=script&lang=js"
import style0 from "./ListaAtendentesUnidade.vue?vue&type=style&index=0&id=f7a8da68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a8da68",
  null
  
)

export default component.exports